import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesWarehouseArrivedPackageMain } from './modules/ui/Main';

const WarehouseArrivedPackagePage = (
  <SuspensePage>
    <PagesWarehouseArrivedPackageMain />
  </SuspensePage>
);

export default WarehouseArrivedPackagePage;
